import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { WorkOrderSettings, WorkOrderSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const WORK_ORDER_SETTINGS_URL = `${SETTINGS_BASE_URL}/workorder`;

export class WorkOrderSettingsRepository extends BaseRestRepository {
  public async getAllWorkOrderSettings(): Promise<WorkOrderSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${WORK_ORDER_SETTINGS_URL}/with-overrides`;
    const res = await this.fetchWithAuth(url);
    return this.getJsonResponse(res);
  }

  public async updateWorkOrderSettings(payload: WorkOrderSettings): Promise<WorkOrderSettings> {
    const url = `${WORK_ORDER_SETTINGS_URL}/company`;
    const res = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify({ settings: payload }) });
    return this.getJsonResponse(res);
  }

  public async updateOverrideWorkOrderSettings(level: string, levelId: string, payload: WorkOrderSettings): Promise<WorkOrderSettings> {
    const url = WORK_ORDER_SETTINGS_URL;
    const res = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(res);
  }

  public async addOverrideSettings(level: string, levelId: string, payload: WorkOrderSettings): Promise<WorkOrderSettings> {
    const url = WORK_ORDER_SETTINGS_URL;
    const res = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(res);
  }

  public async removeOverrideSettings(level: string, levelId: string) {
    const url = `${WORK_ORDER_SETTINGS_URL}/${level}/${levelId}`;
    const res = await this.fetchWithAuth(url, { method: 'DELETE' });
    return this.getJsonResponse(res);
  }
}
